import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, Output, inject } from '@angular/core';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@src/core/services';
import { LogoutService } from '@src/app/modules/auth';

import { DeleteAuthUserDialogComponent } from './components';

@Component({
  selector: 'app-delete-auth-user-link',
  templateUrl: './delete-auth-user-link.component.html',
  styleUrls: ['./delete-auth-user-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAuthUserLinkComponent {
  private readonly userService = inject(UserService);
  private readonly logoutService = inject(LogoutService);
  private readonly translateService = inject(TranslateService);
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  @Input() processing = false;
  @Output() processingChange = new EventEmitter<boolean>();

  private readonly confirmDeleteAuthUserDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DeleteAuthUserDialogComponent, this.injector),
    {
      label: this.translateService.instant('components.deleteAuthUserLink.dialogs.deleteAuthUserHeader'),
      size: 's',
      closeable: false,
    },
  );

  onClickDeleteButton() {
    this.confirmDeleteAuthUserDialog.subscribe({
      next: async res => {
        if (res) {
          this.processingChange.emit(true);
          this.userService.deleteMyProfile().subscribe(() => {
            this.logoutService.logout();
          });
        }
      },
    });
  }
}
